import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
  onExpand: () => void
}

// PX-3649: rendered next to the calendar in both the /consultant (Schedule/Content/Day) and
// /schedule (New/Form) booking flows when a customer is ACFU-progressive-disclosure eligible
// and hasn't yet reached the 4-week ceiling.
const AcfuShowMoreDatesButton = ({ onExpand }: Props) => {
  const { t } = useTranslation()

  return (
    <Button variant="text" onClick={onExpand}>
      {t('common.label.showMoreDates')}
    </Button>
  )
}

export { AcfuShowMoreDatesButton }
